<template>
  <div id='app'>
    <main-navbar v-if='shouldShowNavBar' />
    <div class='main-container'>
      <router-view id='router-view'/>
    </div>
  </div>
</template>
<script>
import MainNavbar from '@/components/shared/MainNavbar'

export default {
  name: 'App',
  components: { MainNavbar },
  computed: {
    shouldShowNavBar () {
      return this.$route.meta.showHeaderAndFooter ?? true
    }
  }
}
</script>

<style lang='scss'>
</style>
